export const caseTrackingCommunicationVisibilityTypeEnum = {
  Private: 1,
  Public: 2,
  Escalation: 3,
}

export const caseTrackingCommunicationSubmissionTypeEnum = {
  RESPONSE_NOT_REQUIRED: 1,
  RESPONSE_REQUIRED: 2,
}
